import ActivityTable from '@activities/components/tables/activity-table/activity-table.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'bpc-profile-activities',
  components: {
    'bpc-activity-table': ActivityTable,
  },
})
export default class ProfileActivities extends Vue {
  public filterConfigName: string = 'public-activities';
  public displayConfigName: string = 'profile-table';
  public extendedFilterConfigName: string = null;
  public categoryFilterConfigName: string = 'activity-category';

  get tenantActivityPageHeader(): any {
    const centerSettings = this.$store.getters['centerSettings/centerSettings'];
    return centerSettings.activity_page_header || '';
  }

  get showActivityCategoryInProfile(): boolean {
    const centerSettings = this.$store.getters['centerSettings/centerSettings'];
    return !!centerSettings.show_activity_categories_in_profile;
  }

  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
